import { BUSINESS, NAV } from "@/lib/content";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#FBF9F6] border-t border-[#E5E0D8] pt-20 pb-10">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
        <div className="md:col-span-6">
          <div className="font-serif text-5xl md:text-7xl tracking-tight leading-none">Simpliq Atelier</div>
          <p className="text-[#5C5A56] mt-6 max-w-md leading-relaxed">
            Handmade custom furniture for homes and businesses. Designed with you in Vaughan, built to last generations.
          </p>
        </div>
        <div className="md:col-span-3">
          <span className="eyebrow">Explore</span>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <button onClick={() => scrollTo(n.to)} className="link-underline text-[#1A1A1A]">{n.label}</button>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <span className="eyebrow">Visit & contact</span>
          <ul className="mt-5 space-y-3 text-[#5C5A56]">
            <li>{BUSINESS.address}</li>
            <li><a href={BUSINESS.phoneHref} className="link-underline">{BUSINESS.phone}</a></li>
            <li><a href={`mailto:${BUSINESS.email}`} className="link-underline">{BUSINESS.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="hairline" />
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 text-xs tracking-widest text-[#8C7A6B] uppercase">
        <span>© 2023 Simpliq Atelier</span>
        <span>Bespoke · Handmade · Vaughan, Ontario</span>
      </div>
    </div>
  </footer>
);
